import { Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
  text: {
    display: "flex",
    flex: 1,
    justifyItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: palette.grey[400],
    padding: spacing(2, 0),
    margin: 0,
    backgroundColor: palette.common.white,
    borderBottomLeftRadius: "0.25rem",
    borderBottomRightRadius: "0.25rem",
    border: `1px solid ${palette.grey[300]}`,
    borderTop: 0,
  },
}));

const Placeholder: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Typography variant="body1" component="p" className={classes.text}>
      {children}
    </Typography>
  );
};

export default Placeholder;
